import api from 'api'

const getCourses = (certificateType: number, certificateId?:number) => {
  return api.get(`/administration/certificates/get_courses?certificate_type=${certificateType}&certificate_id=${certificateId}`).then(({ data }) => {
    return {
      data: data.data.map(({ attributes }: any) => attributes),
    }
  })
}

export default getCourses